import { ComponentProps, forwardRef } from "react";
import { BMCalendar, type BMCalendarRef } from "@traveloka/district-bloom";

import { useLocale } from "../../../../core";
import { appendTestId } from "../../../../utils";
import {
  RangeCalendarProps,
  SingleCalendarProps,
  CalendarPickerComponentProps,
} from "./CalendarPicker";

const CalendarPickerComponent = forwardRef<
  BMCalendarRef,
  CalendarPickerComponentProps
>(function CalendarPickerComponent(props, ref) {
  const { locale } = useLocale();
  const { minDate, maxDate, value, onChange, testID, ...rest } = props;
  const calendarProps: Partial<ComponentProps<typeof BMCalendar>> = {
    ...rest,
    ref,
    minDate,
    maxDate,
    locale,
    variant: "horizontal",
    numberOfRenderedMonth: 1,
    testID: appendTestId(testID, "calendar"),
  };

  if (Array.isArray(value)) {
    return (
      <BMCalendar
        {...calendarProps}
        date={value}
        onChange={onChange as RangeCalendarProps["onChange"]}
      />
    );
  }

  return (
    <BMCalendar
      {...calendarProps}
      date={value}
      onChange={onChange as SingleCalendarProps["onChange"]}
    />
  );
});

export default CalendarPickerComponent;
